var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { showFormDialog } from '@juvare/common-form-ui/showFormDialog';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
export const denyHoursDialog = ({ row, t, handleDenyHours, fetchReload, }) => {
    showFormDialog({
        title: t('timeTracking.denyHoursDialog.title', { participantName: row.columns.participantFullName }),
        config: {
            type: 'form',
            children: [
                {
                    type: 'form.content',
                    html: `<p class="body1">${t('timeTracking.denyHoursDialog.description')}</p>`,
                },
                {
                    type: 'form.advancedRadio',
                    key: 'status',
                    values: [
                        {
                            value: 'deniedInaccurate',
                            label: t('timeTracking.denyHoursDialog.inaccurateLabel'),
                            description: t('timeTracking.denyHoursDialog.inaccurateDescription'),
                            disabled: row.columns.hoursStatus === 'addHours' || row.columns.hoursStatus === 'deniedInaccurate',
                        },
                        {
                            value: 'deniedNoShow',
                            label: t('timeTracking.noShow'),
                            description: t('timeTracking.denyHoursDialog.noShowDescription'),
                        },
                    ],
                    validate: {
                        required: true,
                    },
                },
            ],
        },
        submitLabel: t('timeTracking.denyButtonLabel'),
        onSubmit: (_a) => __awaiter(void 0, [_a], void 0, function* ({ status }) {
            yield handleDenyHours({
                participationId: row.id,
                status: status,
            });
            yield fetchReload();
            showAlertSnackbar({
                message: t('timeTracking.deniedSnackbarMessage'),
                autoHideDuration: 2000,
                type: 'success',
            });
        }),
    });
};
